import { c as _c } from "react/compiler-runtime";
import { accountBalanceQueryKeys, createQueryFn } from '../../../../lib/entry.js';
import { useSuspenseQuery } from '../../../../tanstack/entry.js';
import { getAccountBalance } from '../../../actions/user/entry.js';
const fetcher = createQueryFn(getAccountBalance);
/**
 * Hook to fetch the player's account balance using suspense query.
 *
 * @param queryOptions - Optional query configuration options
 * @returns Suspense query result with account balance data
 */
export function useGetAccountBalance(queryOptions) {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = accountBalanceQueryKeys.player();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = queryOptions?.defaultValue;
  let t2;
  if ($[1] !== t1) {
    t2 = fetcher({
      defaultValue: t1
    });
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== queryOptions || $[4] !== t2) {
    t3 = {
      ...queryOptions,
      queryKey: t0,
      queryFn: t2
    };
    $[3] = queryOptions;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return useSuspenseQuery(t3);
}